export const brand_logos = {
  fr: 'https://cms-cdn.lafourche.fr/94b37e2b-1e00-46ec-805a-557e2eff65b7_Logo+La+Fourche.jpg',
  de: 'https://www.ackerherz.de/icons/brand_logos/de.svg',
};

export const brand_logos_DEFAULT = brand_logos.fr;
